module.exports = __webpack_public_path__ + "img/vivliomprosta.dd2d42e4.jpg";